module.exports = __webpack_public_path__ + "img/icon_map_51_off_111.6a8b2d39.png";